/** Solo preserva destinos MCP internos, sin URLs externas ni tokens en la URL. */
export function safeMcpReturnUrl(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || /[\\\u0000-\u0020]/.test(value)) {
    return null;
  }
  try {
    const parsed = new URL(value, 'https://sirius.invalid');
    if (parsed.origin !== 'https://sirius.invalid' || parsed.hash) return null;
    if (['/mcp/connect', '/mcp/connections'].includes(parsed.pathname) && !parsed.search) {
      return parsed.pathname;
    }
    if (parsed.pathname !== '/mcp/authorize') return null;
    const request = parsed.searchParams.get('request');
    if (!request || !/^[a-zA-Z0-9_-]{1,256}$/.test(request)) return null;
    let parameterCount = 0;
    parsed.searchParams.forEach(() => parameterCount++);
    if (parameterCount !== 1) return null;
    return `/mcp/authorize?request=${encodeURIComponent(request)}`;
  } catch {
    return null;
  }
}
